import LocationType from "../enums/locationType";

const getLocationSearchCommand = (payload) => ({
  locationType: LocationType.fromKey(payload.locationType)?.toString(),
  marketId: payload.marketId,
  stateName: payload.stateName,
  marketState: payload.marketState,
  marketName: payload.marketName,
  marketStateName: payload.marketStateName,
  geoLocationState: payload.geoLocationState,
  city: payload.city,
  neighborhood: payload.neighborhoodName,
  schoolDistrictName: payload.schoolDistrictName,
  schoolDistrictId: payload.schoolDistrictId,
  county: payload.county,
  zip: payload.zip,
  originLatitude: payload.originLatitude,
  originLongitude: payload.originLongitude,
  minimumLatitude: payload.minimumLatitude,
  maximumLatitude: payload.maximumLatitude,
  minimumLongitude: payload.minimumLongitude,
  maximumLongitude: payload.maximumLongitude,
});

export default getLocationSearchCommand;